// The landing screen: wordmark, one form, two modes (sign in / register).
// Resolves once a session cookie exists; main.ts then advances the flow.

interface AuthErrorBody {
  message?: string;
}

async function authRequest(path: string, body: Record<string, string>): Promise<string | null> {
  const res = await fetch(`/api/auth/${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (res.ok) return null;
  const parsed = (await res.json().catch(() => ({}))) as AuthErrorBody;
  return parsed.message ?? `something went wrong (${res.status})`;
}

export function showLanding(root: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    const screen = document.createElement("div");
    screen.className = "screen landing";
    screen.innerHTML = `
      <div class="panel">
        <div class="wordmark-large">BEBOP</div>
        <p class="tagline">Live DJs. One street. Doors are open.</p>
        <div class="mode-tabs">
          <button type="button" class="mode active" data-mode="register">Register</button>
          <button type="button" class="mode" data-mode="signin">Sign in</button>
        </div>
        <form>
          <input name="email" type="email" placeholder="email" autocomplete="email" required />
          <input name="password" type="password" placeholder="password (8+ characters)"
                 autocomplete="new-password" minlength="8" required />
          <button type="submit" class="primary">Step inside</button>
          <div class="form-error" role="alert"></div>
        </form>
      </div>
    `;
    root.append(screen);

    const form = screen.querySelector("form") as HTMLFormElement;
    const email = screen.querySelector("[name=email]") as HTMLInputElement;
    const password = screen.querySelector("[name=password]") as HTMLInputElement;
    const error = screen.querySelector(".form-error") as HTMLDivElement;
    const submit = screen.querySelector(".primary") as HTMLButtonElement;
    let mode: "register" | "signin" = "register";

    for (const button of screen.querySelectorAll<HTMLButtonElement>(".mode")) {
      button.addEventListener("click", () => {
        mode = button.dataset.mode as typeof mode;
        for (const b of screen.querySelectorAll(".mode"))
          b.classList.toggle("active", b === button);
        password.autocomplete = mode === "register" ? "new-password" : "current-password";
        error.textContent = "";
      });
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      error.textContent = "";
      submit.disabled = true;
      const run = async () => {
        const failure =
          mode === "register"
            ? await authRequest("sign-up/email", {
                email: email.value,
                password: password.value,
                // better-auth requires a user name; the character name is
                // chosen in the creator, so the email's local part will do.
                name: email.value.split("@")[0] ?? "player",
              })
            : await authRequest("sign-in/email", {
                email: email.value,
                password: password.value,
              });
        if (failure) {
          error.textContent = failure;
          submit.disabled = false;
          return;
        }
        screen.remove();
        resolve();
      };
      void run();
    });
  });
}
